// extracted by mini-css-extract-plugin
export var chip = "_45-0";
export var filterDropdown = "_45-5";
export var filterItem = "_45-6";
export var icon = "_45-1";
export var removeButton = "_45-3";
export var removeIcon = "_45-4";
export var separator = "_45-2";